export var WIGGLE_VALIDATION_ACTION;
(function (WIGGLE_VALIDATION_ACTION) {
    WIGGLE_VALIDATION_ACTION["SET_WIGGLE_VALIDATION_DATA"] = "SET_WIGGLE_VALIDATION_DATA";
})(WIGGLE_VALIDATION_ACTION || (WIGGLE_VALIDATION_ACTION = {}));
export function setWiggleValidationData(wiggleId) {
    return {
        type: WIGGLE_VALIDATION_ACTION.SET_WIGGLE_VALIDATION_DATA,
        wiggleId
    };
}
